import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import {HubConnectionBuilder, JsonHubProtocol, HubConnection, LogLevel} from "@microsoft/signalR";
//import {ConsoleLogger} from "@aspnet/signalR";
//import {JsonHubProtocol} from "@aspnet/signalR";
//import {LogLevel} from "@aspnet/signalR";

// import * as signalR from "@aspnet/signalr-client";

@NgService({
    token: Token.SignalRService,
    dependencies: [
        Token.$RootScope,
        Token.$Q,
    ]
})
export class SignalrService {
    constructor(
        private $rootScope,
        private $q: ng.IQService
    ) {

    }
        
    private crudConnectionPromise: Promise<any>;
    private notificationConnectionPromise: Promise<any>;
    private crudConnection: HubConnection;
    private notificationConnection: signalR.HubConnection;
    // private crudHubProxy: signalR.HubProxy;
    // private notificationHubProxy: signalR.HubProxy;
    private stopping: boolean;

    private stop() {
        this.stopping = true;
        this.crudConnection.stop();
        this.notificationConnection.stop();
    }

    public start() {

        // adapted from https://docs.microsoft.com/en-us/aspnet/core/signalr/javascript-client?view=aspnetcore-2.1
        // Surprise, surprise, as of today (July, 2018) HubConnectionBuilder which the documentation references
        // isn't in the npm aspnet/signalr project.
        this.crudConnection = new (<any>window).signalR.HubConnectionBuilder()
        .withUrl("/crudHub", {
            serverTimeoutInMilliseconds: 100000000
        })
        .withHubProtocol(new JsonHubProtocol())
        .configureLogging((<any>window).signalR.LogLevel.Information)
        .build(); 

        this.notificationConnection = new (<any>window).signalR.HubConnectionBuilder()
        .withUrl("/notificationHub", {
            serverTimeoutInMilliseconds: 100000000
        })
        .withHubProtocol(new JsonHubProtocol())
        .configureLogging((<any>window).signalR.LogLevel.Information)
        .build();

        var promises = [this.crudConnectionPromise = this.crudConnection.start(), this.notificationConnectionPromise = this.notificationConnection.start()];

        return this.$q.when(promises);
    }

    public notificationOn(eventName: string, callback?: (...result: any[]) => void) {
        if (this.notificationConnection) this.notificationConnection.on(eventName, callback);
    }

    public notificationOff(eventName: string, callback?: (...result: any[]) => void) {
        if (this.notificationConnection) this.notificationConnection.off(eventName, callback);
    }

    public notificationInvoke(methodName: string, ...data: any[]) {
        if (this.notificationConnectionPromise) {
            this.notificationConnectionPromise.then(() => {
                this.notificationConnection.invoke.apply(this.notificationConnection, [methodName].concat(data))
                    .then((result) => {
                        this.$rootScope.$apply(() => {
                        });
                    });
            });
        }
    }

    public on(eventName: string, callback?: (...result: any[]) => void) {
        if (this.crudConnection) this.crudConnection.on(eventName, callback);
    }

    public off(eventName: string, callback?: (...result: any[]) => void) {
        if (this.crudConnection) this.crudConnection.off(eventName, callback);
    }

    public invoke(methodName: string, ...data: any[]) {
        if (this.crudConnectionPromise) {
            this.crudConnectionPromise.then(() => {
                this.crudConnection.invoke.apply(this.crudConnection, [methodName].concat(data))
                    .then((result) => {
                        this.$rootScope.$apply(() => {
                        });
                    });
            });
        }
    }
        
}
